export enum Role {
  'manager' = 'manager',
  'salesman' = 'salesman',
  'salesman_cashier' = 'salesman_cashier',
  'commercial_manager' = 'commercial_manager',
  'cashier' = 'cashier',
}
